import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

import { useProfileName } from "../../auth/ProfileProvider";
import { EmptyState } from "../../components/empty-state/EmptyState";

export function DashboardEmpty() {
  const { t } = useTranslation();

  const { name } = useProfileName();

  return (
    <div className={css({ margin: "auto" })}>
      <EmptyState
        hideBorder
        illustration="check-todo"
        size={132}
        title={t("Welcome, {{firstName}}!", {
          firstName: name.givenName,
        })}
        description={
          <Trans>
            When someone sends you a background check, it will appear here.
          </Trans>
        }
      />
    </div>
  );
}
